module.exports = __webpack_public_path__ + "img/sponsor-2.a7da1f7f.jpg";